import React from 'react'
import Image from 'material-ui-image'
import Picture from "../../Assets/Peyronie.png";
import CardMedia from "@material-ui/core/CardMedia";

const Peyronie_EN = () => {
    return (
        <section id="about1">
            <div className="row">
                <h2>What is Peyronie’s Disease? </h2>
                <p className="white">
 Induratio Penis Plastica (IPP) is a benign disease that affects the tunica albuginea of the corpora cavernosa. The disease presents with a variety of symptoms, including penile pain during erection, plaque formation in the tunica albuginea, erectile dysfunction (ED), penile deviation, and severe curvatures and deformities of the penis, leading to penile shortening. Mental distress and depression are also common among those affected by the disease.
                        <hr/>


                    <h2>What can cause Peyronie’s Disease?</h2>

The development of Induratio Penis Plastica (IPP) is most commonly observed in the age group of 40 to 60 years. While the exact etiology of the disease remains uncertain, repeated microtrauma to the penis during sexual activity or arousal is considered a potential cause. This microtrauma may lead to inflammation in the area where the corpus cavernosum septum meets the tunica albuginea, which in turn results in an increase in fibroblast proliferation and collagen formation. If the inflammation persists or if microtrauma recurs in the same area, it can cause tissue remodeling and the formation of a fibrotic plaque. This plaque ultimately results in varying degrees of penile curvature.
                        <hr/>


                    <h2>Course of the disease</h2>

The course of Induratio Penis Plastica (IPP) is typically divided into two phases: the acute and chronic phase.

During the acute phase, which lasts approximately 6-18 months, active inflammation takes place. Symptoms during this phase include painful erections, deformation of the penis, and pain in the non-erect state. A soft nodule, or plaque, may already be palpable at this stage. Penile pain often subsides during the acute phase.

The chronic phase is characterized by stabilization of penile deformity and relief from penile pain. The timing of this phase varies between patients and can occur after approximately 12 to 18 months, according to studies.
                        <hr/>

 

 
                    <h2>Which symptoms are typical for Peyronie’s disease:</h2>
                    <p>Peyronie's disease is characterized by several typical symptoms, including:</p>
                    <ol>
                        <li>Penile pain during erection or in the normal (flaccid) state </li>
                        <li>Palpable lumps on the shaft of the penis, hardening of the penis </li>
                        <li>Occurrence of curvature with varying degrees and orientation </li>
                        <li>Development of indentation defects up to hourglass deformities </li>
                        <li>Penile shortening with progression of the disease </li>
                        <li>Occurrence of erectile dysfunction in over 50% of patients with IPP </li>
                        <li>Psychological stress </li>
                        <li>Relationship problems </li>
                        <li>Decrease in libido </li>
                        <li>Painful sexual intercourse </li>
                    </ol>
 
These symptoms can vary in severity and may cause significant physical and psychological distress. Peyronie's disease can have a significant impact on sexual function, making it important for affected individuals to seek medical attention and treatment.
                        <hr/>
                    <h2>Which complications of Peyronie's disease can occur with time without treatment:</h2>
If left untreated, Peyronie's disease can lead to a range of complications over time, including:

                    <ol>
                        <li>Inability to have sexual intercourse  </li>
                        <li>Difficulty achieving or maintaining an erection (erectile dysfunction)  </li>
                        <li>Anxiety or stress about sexual abilities or the appearance of your penis  </li>
                        <li>Stress on your relationship with your sexual partner  </li>
                        <li>Difficulty fathering a child, because intercourse is difficult or impossible  </li>
                        <li>Reduced penis length  </li>
                        <li>Penile pain  </li>
                    </ol>

 
It is important to seek medical attention and treatment for Peyronie's disease as early as possible to minimize the risk of these complications and improve quality of life.

                        <hr/>

                    <h2>Innovative conservative non-invasive treatment of Peyronies disease:</h2>


Induratio Penis Plastica (IPP) has traditionally been treated with drugs and surgery, but these methods can be ineffective and fraught with complications. A new multimodal non-invasive therapy concept offers hope for patients with IPP. The treatment includes:

                    <ol>
                        <li>Therapeutic ultrasound</li>
                        <li>Extracorporeal shock wave therapy (ESWT)</li>
                        <li>Electromotive drug application (EMDA®)</li>
                        <li>Concomitant drug therapy</li>

                    </ol>
    
 
 

                    <p>The four cornerstones of the new therapy concept:</p>

For the best results, it's important that patients undergo therapy as early as possible, ideally during the inflammatory phase or at the first signs of clinical symptoms like pain during erection, lump formation, or incipient penile deformation.
Even in the advanced stages of the disease with pronounced penile deformities or bends that make sexual activity impossible, this new therapy concept has shown success. Our clinical observations have revealed a synergistic effect of the therapy, which is performed on an outpatient basis. This non-invasive treatment offers hope for patients with IPP and may spare many from the need for surgery.


                        <hr/>

 

                    <h2>Low-intensity shockwave therapy in Peyronie’s disease: </h2>

Low-intensity shockwave therapy (LiESWT) is a highly effective treatment for Peyronie’s disease that can improve penile pain, curvature, plaque size, and erectile function during the early inflammatory phase, without any adverse side effects. However, the therapeutic mechanisms of LiESWT on Peyronie’s disease are not yet fully understood.

One possible explanation is that shock waves can cause direct plaque damage through a phenomenon called cavitation, where bubbles generated by the reflection of shock waves collapse and generate large forces that cause plaque damage. Additionally, an inflammatory reaction caused by LiESWT can lead to plaque lysis, resorption of calcifications, and their removal by macrophages.

Studies have also shown that LiESWT can increase vascularity and decrease the packing and clumping of collagen fibers within the plaques through heat induction. Subjectively, patients often report a smoother or softened plaque after LiESWT.

The evidence for the efficacy of LiESWT for the treatment of Peyronie’s disease is growing, and it is now recommended in the 2021 European guidelines as a treatment option for penile pain during the acute phase of the disease.

                        <hr/>


                    <h2>Transdermal electromotive multi-drug administration for Peyronie's disease (EMDA): </h2>

Electromotive drug administration (EMDA) and iontophoresis are techniques that use a small electric charge to deliver medication through the skin transdermally. Iontophoresis involves the transport of ions through tissue by an electric current, causing electrokinetic repulsion of positively charged medication towards the target tissue, reducing systemic side effects. This technique is also thought to provide superior tissue penetration for the transdermal application of medications.

In patients with Peyronie's disease, transdermal iontophoretic administration of steroids and verapamil has shown promising results without the side effects associated with oral or intraplaque injection therapies. EMDA and iontophoresis are minimally invasive techniques that can be effective in delivering medication locally and are a promising treatment option for patients with Peyronie's disease. 

                        <hr/>


                     <h2>Therapeutic ultrasound: </h2>

Ultrasound is a form of mechanical energy that falls under the Electro Physical Agents grouping, even though it is not strictly electrical. Sound energy is mechanical vibration at increasing frequencies, with ultrasound referring to frequencies beyond the upper limit of the normal human sound range of 16 Hz to 15-20,000 Hz in children and young adults. Frequencies used for therapeutic effects are typically between 1.0 and 3.0 MHz. Low-frequency ultrasound waves have greater tissue penetration but are less focused. For deeper injuries and patients with substantial subcutaneous fat, 1.0 MHz frequency is recommended. For more superficial lesions at a depth of 1-2 cm, 3.0 MHz frequency is recommended. The dose of therapeutic ultrasound can be varied by altering wave amplitude and intensity, and it can be used in pulsed or continuous form. The latter form has a greater heating effect, with an estimated tissue temperature rise of 40-45°C for optimal treatment. Therapeutic ultrasound is a non-invasive treatment option with no side effects in patients with Peyronie's disease. It can increase blood flow, reduce muscle spasm, increase collagen fiber extensibility, reduce pain, and induce a pro-inflammatory response.


                        <hr/>

                     <h2>Positive effects of multimodal therapy on the course of the disease:</h2>

Multimodal therapy has shown a significant improvement in symptoms after just a few sessions, with consistent application leading to tissue remodeling in the penile corpus cavernosum.

The therapy has been clinically observed to provide the following therapeutic effects:



                    <ol>
                        <li>Formation of new blood vessels</li>
                        <li>Activation of stem cells</li>
                        <li>Improvement of penile blood circulation</li>
                        <li>Penis enlargement</li>
                        <li>Decrease in penile pain</li>
                        <li>Decrease of penile plaque</li>
                        <li>Improvement of penile deviation</li>
                        <li>Improvement of mental health</li>
                        <li>Improvement of sexual life</li>
                    </ol>
    
 
                        <hr/>

                     <h2>Treatment possibilities in our urological practice for patients with Peyronie’s Disease: </h2>


Our urological practice offers a multimodal therapy approach for patients with Peyronie's Disease. The therapy consists of six cycles, each lasting approximately two weeks. Each cycle includes three components: shock wave treatment, therapeutic ultrasound, and transdermal electromotive multi-drug administration. Shock wave treatment is administered for 10-15 minutes at the start of each cycle, followed by a few minutes of therapeutic ultrasound. The final step in each cycle is a 20-minute transdermal electromotive multi-drug administration (EMDA) therapy with Verapamil and Dexamethasone. After completing the cycles, patients may be prescribed a treatment plan that includes penile traction device use for 3-6 months, tadalafil intake, and 12 months of antioxidant therapy. Our clinical observations have shown that this therapy approach stops the progression of the disease in almost all patients, improves blood flow to the penis, enhances erectile function, reduces penile curvature, and even results in a few centimeters of penis enlargement. Furthermore, our practice has not observed any side effects thus far.

                </p>
            </div>
        </section>
    )
}

export default Peyronie_EN
















 



// WEBPACK FOOTER //
// ./src/Components/Peyronie/Peyronie_EN.js